export default "__VITE_ASSET__D5b7KhJW__"